import { zumperApi } from "api/zumper";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedAutoAddCard } from "views/settings-integration/integrations/shared/FeedAutoAddCard";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const ZumperView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectZumper, isPending: isDisconnecting } = useMutation({
    mutationKey: ["ZUMPER", "DELETE"],
    mutationFn: () => zumperApi.disconnect(),
    onSuccess: () => {
      toast.success("Zumper integration disconnected successfully");
      refreshPartnerData();
      navigate("/settings/integration");
    },
    onError: (err) => {
      toast.error(getErrorMessage(err));
    }
  });

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.ZUMPER}
          name="Zumper"
          path="/settings/integration/zumper"
          onDisconnect={() => disconnectZumper()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <div className="space-y-6">
        <FeedAutoAddCard feed="zumper" feedLabel="Zumper" />
        <FeedListingsCard feed="zumper" feedLabel="Zumper" />
      </div>
    </Layout>
  );
};
